module.exports = __webpack_public_path__ + "img/cj-bg.0466c099.jpg";